<app-header></app-header>
<ngx-spinner></ngx-spinner>
<!-- navbar-end -->
<section class="content-banner">
  <div class="">
    <h1>{{ "FAQ_INFO.FAQ" | translate }}</h1>
    <p class="m-0">
      {{ "FAQ_INFO.MESAAGE" | translate }}
    </p>
  </div>
</section>
<section class="faq-page wrapper">
  <div class="container">
    <div class="row justify-content-center">
      <!-- <div class="col-12 col-sm-12 col-md-4 col-lg-4">
        <div class="side-text">
          <h1 class="mb-4">How can we help you?</h1>
          <p class="m-0 text-secondary">Need Answers? Find them here!</p>
        </div>
      </div> -->
      <div class="col-12 col-sm-12 col-md-11 col-lg-8">
        <mat-accordion *ngFor="let faq of faqs; index as i">
          <mat-expansion-panel
            hideToggle="false"
            [expanded]="step == i"
            (closed)="closeEvent(i)"
            (opened)="setStep(i)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <p [innerHtml]="faq?.question" class="mb-0 text-uppercase"></p>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p
              *ngIf="isOpen && step == i"
              [innerHtml]="faq?.answer"
              class="text-gray"
            ></p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <div class="record-not-available" *ngIf="faqs?.length == 0">
      <div class="text-center">
        <img src="assets/images/no-recoard-playlist.png" />
        <p class="no-recored-content text-secondary">
          {{ "RECORD_NOT_FOUND" | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>